<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center
            >EDI TEAM Execution ({{ EdiExecutionModel.ccType }})</b-navbar-brand
          >
          <b-navbar-nav
            class="ml-auto"
            v-if="EdiExecutionModel.ccType == 'Import'"
          >
            <b-nav-form>
              <b-button
                v-if="mainEntryData[0].shippingArrivalNoticmailSentDate == null"
                @click="SendShipmentArrival"
                size="sm"
                variant="warning"
                >Send Shipment Arrival Notice</b-button
              >
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="this.ALLMODULE ? this.ALLMODULE : ''"
          :jobSeriesBanner="this.JOBSERIES ? this.JOBSERIES : ''"
          :bannerClientName="this.EXPORTER ? this.EXPORTER : ''"
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <b-button
              size="sm"
              class="pull-right"
              @click="showDocModal"
              variant="dark"
              >Upload SB Documents</b-button
            >
            <div>
              <container-component
                v-if="ALLMODULE"
                :allModuleIdContainer="ALLMODULE"
                JOB="CC"
                :TYPE="TYPE == 'Import' ? 'IMPORT' : ''"
              />
            </div>
            <div v-if="proceedNext == '1'">
              <md-layout md-gutter class="gutr">
                <!-- <md-layout md-flex="40">
                  <label for="vgmBy">VGM By</label>
                  <model-list-select
                    :list="vgmByList"
                    option-value="vgmByValue"
                    option-text="vgmByText"
                    placeholder="Select"
                    name="vgmBy"
                    id="vgmBy"
                    v-model="EdiExecutionModel.vgmBy"
                  ></model-list-select>
                </md-layout> -->
                <!-- <md-layout md-flex="5"></md-layout> -->
                <md-layout
                  md-flex="35"
                  v-if="EdiExecutionModel.vgmBy == 'SHIPPER'"
                >
                  <b-button
                    size="sm"
                    style="margin-top: 35px !important"
                    v-if="EdiExecutionModel.vgmBy == 'SHIPPER'"
                    @click="showDocModal"
                    variant="dark"
                    >Upload Shipper VGM</b-button
                  >

                  <!-- <md-input-container>
                  <label>Signed VGM by Shipper If Any</label>
                  <md-file
               
                    name="vgmUpload"
                    id="vgmUpload"
                    v-model="EdiExecutionModel.vgmUpload"
                    @selected="onFileChange(0,'VGM')"
                    multiple
                  ></md-file>
                </md-input-container> -->
                </md-layout>
              </md-layout>

              <md-layout
                md-gutter
                v-if="viewVgmDoc.length > 0 || viewVgmDoc.length > 0"
              >
                <md-layout
                  md-flex="100"
                  v-for="(item, index) in viewVgmDoc"
                  :key="index"
                >
                  <md-layout md-flex="45"></md-layout>
                  <a
                    v-if="EdiExecutionModel.ccType == 'Export'"
                    :href="`${docURL}/CC_Export_Uploads/` + item"
                    target="_blank"
                    download
                    >View Document - {{ index + 1 }}</a
                  >
                  <a
                    v-else
                    :href="`${docURL}/CC_Import_Uploads/` + item"
                    target="_blank"
                    download
                    >View Document - {{ index + 1 }}</a
                  >
                </md-layout>
              </md-layout>
              <!-- <md-layout md-gutter class="gutr" v-model="EdiExecutionModel.challanNo">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="40" v-if="EdiExecutionModel.ccType=='Import'">
            <label>Challan No.</label>
            <b-input name="challanNo" id="challanNo"></b-input>
          </md-layout>
            </md-layout>-->
              <!-- <md-layout
          md-gutter
          class="gutr"
          v-if="checkStatusApproved==false && EdiExecutionModel.ccType=='Import'"
        >
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="90">
            <label>Remarks</label>
            <b-textarea name="mainRemarks" id="mainRemarks" v-model="EdiExecutionModel.mainRemarks"></b-textarea>
          </md-layout>
            </md-layout>-->
              <div class="gutr">
                <div>
                  <b-button
                    class="mt-3"
                    variant="primary"
                    id="addButtonLoaderBL"
                    @click="emailChecklist('0')"
                    >Save & Submit
                  </b-button>
                </div>
                              <div>
                <b-button
                  v-if="EdiExecutionModel.ccType == 'Export'"
                  variant="primary"
                  class="mt-1"
                  id="addButtonLoaderHand"
                  @click="emailChecklist('handover')"
                  >{{
                    portType == "Sea_Port"
                      ? "Save & Proceed to Gate-in-at Terminal by Road"
                      : "Save & Proceed to Handover"
                  }}</b-button
                >

                <md-spinner
                  md-indeterminate
                  id="loaderHand"
                  style="display: none"
                ></md-spinner>
              </div>
                                    <!-- // Added By Priyanshu Singh Start -->
                                     <!-- v-if="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh'" -->
              <b-button
                 
                  class="mt-1"
                  variant="primary"
                  @click="emailChecklist('PAYTEST')"
                  id="addButtonLoaderVGM"
                  >Save & Proceed S-Line Payment</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loaderVGM"
                  style="display: none"
                ></md-spinner>
                <br />
                      <!-- // Added By Priyanshu Singh End -->
                      
                <div>
                  <b-button
                    v-if="EdiExecutionModel.ccType == 'Export'"
                    variant="primary"
                    class="mt-1"
                    id="addButtonLoaderBL"
                    @click="emailChecklist('BL')"
                    >Save & Proceed to BL</b-button
                  >

                  <md-spinner
                    md-indeterminate
                    id="loaderBL"
                    style="display: none"
                  ></md-spinner>


                </div>
              </div>
              <!-- <div class="col-md-12 gutr">
              <b-button
                v-if="EdiExecutionModel.ccType=='Export'"
                variant="primary"
                class="pull-right"
                id="addButtonLoaderPay"
                @click="emailChecklist('payment')"
              >Save & Proceed to Payment</b-button>

              <md-spinner md-indeterminate id="loaderPay" style="display:none"></md-spinner>
            </div>-->

              <div>
                <b-button
                  v-if="EdiExecutionModel.ccType == 'Import'"
                  class="mt-1"
                  variant="primary"
                  id="addButtonLoaderVgm"
                  @click="emailChecklist('vgm')"
                  >Save & Proceed To Execution</b-button
                >
                <b-button
                  v-if="
                    EdiExecutionModel.ccType == 'Export' &&
                    EdiExecutionModel.vgmBy != 'SHIPPER'
                  "
                  class="mt-1"
                  variant="primary"
                  id="addButtonLoaderVgm"
                  @click="emailChecklist('vgm')"
                  >Save & Proceed To VGM</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loaderVgm"
                  style="display: none"
                ></md-spinner>
              </div>
              <div>
              

              </div>
            </div>
            <!-- <span
              v-if="
                EdiExecutionModel.ccType == 'Export' &&
                containerCheck == false &&
                EdiExecutionModel.ediExecutionId != ''
              "
              class="error"
              >Note: Please Enter All Container Details on First Page To proceed
              Further..!</span
            > -->
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <div v-if="ALLMODULE">
      <b-modal
        size="xl"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div>
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button
          class="mt-3"
          variant="outline-danger"
          block
          @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="alertAddSeaImp"
      @close="Onclose"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="message"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ContainerComponent from "../allModuleForm/containerComponent.vue";

import { quillEditor } from "vue-quill-editor";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Custom Clearance") &&
      this.$sessionsStorage.get("editCcImportId") != undefined &&
      this.$sessionsStorage.get("editCcImportId") != "" &&
      this.$sessionsStorage.get("editCcType") != undefined &&
      this.$sessionsStorage.get("editCcType") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/CCImport/CCImportEntry");

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    proccedNext: {
      handler(newVal, oldVal) {
        alert();
      },
      deep: true,
    },
  },
  data() {
    return {
      syncType: '',
      syncSeries: '',
      syncFlag: false,
      invnoErrFlag: false,
      vgmByList: [
        {
          vgmByText: "PRIDEL",
          vgmByValue: "PRIDEL",
        },
        {
          vgmByText: "SHIPPER",
          vgmByValue: "SHIPPER",
        },
      ],
      proccedNext: this.$sessionsStorage.get("completed"),
      docURL: URL_BASE_DOC,
      editorOption: {
        modules: {},
      },
      arrayApproved: [false],
      ALLMODULE: "",
      TYPE: "",
      JOBSERIES: "",
      EdiExecutionModel: {
        allModuleId: "",
        checklistUpload: "",
        vgmUpload: "",
        vgmBy: "",
        ediExecutionId: "",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),
        ccType: "",
        assignmentNumber: "",
        DIN: "",
        IRN: "",
        billEntryNumber: "",
        uploadBoe: [],
        billEntryDate: "",
        challanNo: "",
        mainRemarks: "",
      },

      errorArrayEdiExecution: {
        // DIN: "",
        // IRN: "",
        // billEntryNumber: "",
        // uploadBoe: "",
        // billEntryDate: ""
      },

      arrayErrorEdit: {
        // DIN: "Enter Din ",
        // IRN: "Enter IRN ",
        // billEntryNumber: "Enter Bill Entry Number",
        // uploadBoe: "Please Upload Boe",
        // billEntryDate: "Select BIll Entry Date"
      },
      multiShippingBill: [],
      errorChecklist: {
        checklistUpload: "",
      },

      arrayErrorCheckList: {
        checklistUpload: "Please Upload Checklist",
      },

      UploadChecklist: {
        checklistUpload: "",
        Remark: "",
        status: "Sent For Approval",
        uploadCheckListId: "",
      },
      editorContent: "",
      isLoading: false,
      showAdd: false,
      uploadIndex: 0,

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      allAgentColoader: [],
      CommodityAll: {},
      autoClientName: {},
      validate: true,
      newContainerFlow: null,
      multipleUpload: [],
      mainEntryData: [],
      ccExecDetail: [],
      pageRoute: "",
      portType: "",
      statusList: [
        {
          statusText: "Approved",
          statusVal: "Approved",
        },
        {
          statusText: "Not Approved",
          statusVal: "Not Approved",
        },
      ],
    };
  },

  mounted() {
    console.log(this.$store.getters.storeProceedContainer, "uiyiuyyi");
  },
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    VueTrix,
    quillEditor,
    DocForm,
    ContainerComponent,
    BannerComponent,
  },
  computed: {
    containerCheck() {
      if (this.containerArray.length > 0) {
        let array = this.containerArray.filter((x) => {
          return x.containerNo;
        });
        return array.length == this.containerArray.length ||
          this.newContainerFlow == "1"
          ? true
          : false;
      } else {
        return false;
      }
    },
    proceedNext() {
      return this.$store.getters.storeProceedContainer;
    },
    clientList() {
      return this.getCLientData;
    },
    firstBlUploadView() {
      return this.EdiExecutionModel.uploadBoe != ""
        ? this.EdiExecutionModel.uploadBoe.split(",")
        : [];
    },
    viewVgmDoc() {
      return this.EdiExecutionModel.vgmUpload != ""
        ? this.EdiExecutionModel.vgmUpload.split(",")
        : [];
    },

    viewApprove() {
      return this.EdiExecutionModel.checklistUpload != ""
        ? this.EdiExecutionModel.checklistUpload.split(",")
        : [];
    },

    // checkStatusApproved() {
    //   if (this.multipleUpload.length > 0) {
    //     return this.multipleUpload.filter(x => {
    //       return x.status == "Approved";
    //     }).length > 0
    //       ? false
    //       : true;
    //   } else {
    //     return true;
    //   }
    // }
  },
  methods: {
    showDocModal() {
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    SendShipmentArrival() {
      this.isLoading = true;
      let payLoad = {
        mailAlert: "mailAlert",
        sendMail: "Yes",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),
      };

      if (this.validate == true) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/ccShipmentArrivalNoticeMailSend.php`,
          data: JSON.stringify(payLoad),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              this.isLoading = false;
              this.alert.content = "Shipment Arrival Notice Sent";
              this.$refs["message"].open();
            }
          })
          .catch((error) => {});
      }
    },
    addAdditionalHBL() {
      let SB = {
        sbUpload: "",
        sbNo: "",
        sbDate: "",
        shipperInvUpload: "",
        shipperInvNo: "",
        shipperInvDate: "",
        crnNo: "",
        cartingDate: "",
      };

      this.multiShippingBill.push(SB);
    },
    Onclose(type) {
      if (this.EdiExecutionModel.ccType == "Import") {
        if (type != "cancel") {
          this.$router.push({
            path: "/CCImport/ExecutionImport",
          });
        }
      } else {
        if (this.pageRoute == "vgm") {
          this.$router.push({
            path: "/CCImport/newCCExVgm",
          });
        } else if (this.pageRoute == "payment") {
          this.$router.push({
            path: "/CCImport/paymentDetail",
          });
        } else if (this.pageRoute == "handover") {
          this.$router.push({
            path: "/CCImport/newCCHandoverToRail",
          });
        } else if (this.pageRoute == "BL") {
          this.$router.push({
            path: "/CCImport/ccExBL",
          });
        // Added By Priyanshu Singh Start
        } else if (this.pageRoute == "PAYTEST") {
          this.$router.push({
            path: "/CCImport/ccSLinePaymentExportN",
          });
        }
        // Added By Priyanshu Singh End
      }
    },

    doLoading() {},
    getData() {
      this.isLoading = true;
      this.multiShippingBill = [];

      let array = [];
      let vehicle_drive = {
        itemCode: "itemCode",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),
        ccType: this.$sessionsStorage.get("editCcType"),
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Custom/fetchEdiExecution_NewV3.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data);
            if (data.newContainerFlow.length > 0) {
              this.newContainerFlow = data.newContainerFlow;
            } else {
              this.newContainerFlow = "";
            }

            if (data.ccImportDetails.length > 0) {
              this.mainEntryData = data.ccImportDetails;
              this.portType = data.ccImportDetails[0].portType;
              this.ALLMODULE = data.ccImportDetails[0].allModuleId;
              this.TYPE = data.ccImportDetails[0].ccType;
              this.JOBSERIES = data.ccImportDetails[0].ccImportSeries;
              this.EXPORTER = data.ccImportDetails[0].Importer;
              this.EdiExecutionModel.assignmentNumber =
                data.ccImportDetails[0].ccImportSeries;
              this.EdiExecutionModel.ccType = data.ccImportDetails[0].ccType;
              if (data.ccExecDetail.length > 0) {
                this.ccExecDetail = data.ccExecDetail;
                this.EdiExecutionModel.ediExecutionId =
                  data.ccExecDetail[0].ediExecutionId;
                Object.keys(this.EdiExecutionModel).map((x) => {
                  this.EdiExecutionModel[x] = data.ccExecDetail[0][x] || "";
                });
                if (
                  data.ccExecDetail[0].billEntryNumber != null &&
                  data.ccExecDetail[0].billEntryNumber != ""
                ) {
                  let billNoArry =
                    data.ccExecDetail[0].billEntryNumber.split(",");
                  let uploadBill = [];
                  let billDate = [];
                  let uploadSInv = [];
                  let sInvDate = [];
                  let sInvNo = [];
                  let crNoArry = [];
                  let cartDate = [];

                  if (
                    data.ccExecDetail[0].uploadBoe != null &&
                    data.ccExecDetail[0].uploadBoe != ""
                  ) {
                    uploadBill = data.ccExecDetail[0].uploadBoe.split(",");
                  }
                  if (
                    data.ccExecDetail[0].billEntryDate != null &&
                    data.ccExecDetail[0].billEntryDate != ""
                  ) {
                    billDate = data.ccExecDetail[0].billEntryDate.split(",");
                  }
                  if (
                    data.ccExecDetail[0].shipperInvUpload != null &&
                    data.ccExecDetail[0].shipperInvUpload != ""
                  ) {
                    uploadSInv =
                      data.ccExecDetail[0].shipperInvUpload.split(",");
                  }
                  if (
                    data.ccExecDetail[0].shipperInvNo != null &&
                    data.ccExecDetail[0].shipperInvNo != ""
                  ) {
                    sInvNo = data.ccExecDetail[0].shipperInvNo.split(",");
                  }
                  if (
                    data.ccExecDetail[0].shipperInvDate != null &&
                    data.ccExecDetail[0].shipperInvDate != ""
                  ) {
                    sInvDate = data.ccExecDetail[0].shipperInvDate.split(",");
                  }
                  if (
                    data.ccExecDetail[0].crnNo != null &&
                    data.ccExecDetail[0].crnNo != ""
                  ) {
                    crNoArry = data.ccExecDetail[0].crnNo.split(",");
                  }
                  if (
                    data.ccExecDetail[0].cartingDate != null &&
                    data.ccExecDetail[0].cartingDate != ""
                  ) {
                    cartDate = data.ccExecDetail[0].cartingDate.split(",");
                  }

                  if (billNoArry.length > 0) {
                    for (let q = 0; q < billNoArry.length; q++) {
                      // let ccCon = y.multipleContainerType.split(",");
                      let SB = {
                        sbUpload: uploadBill[q],
                        sbNo: billNoArry[q],
                        sbDate: billDate[q],
                        shipperInvUpload: uploadSInv[q],
                        shipperInvNo: sInvNo[q],
                        shipperInvDate: sInvDate[q],
                        crnNo: crNoArry[q],
                        cartingDate: cartDate[q],
                      };

                      this.multiShippingBill.push(SB);
                    }
                  } else {
                    let SB = {
                      sbUpload: "",
                      sbNo: "",
                      sbDate: "",
                      shipperInvUpload: "",
                      shipperInvNo: "",
                      shipperInvDate: "",
                      crnNo: "",
                      cartingDate: "",
                    };

                    this.multiShippingBill.push(SB);
                  }
                }
              } else {
                let SB = {
                  sbUpload: "",
                  sbNo: "",
                  sbDate: "",
                  shipperInvUpload: "",
                  shipperInvNo: "",
                  shipperInvDate: "",
                  crnNo: "",
                  cartingDate: "",
                };

                this.multiShippingBill.push(SB);
              }

              if (data.ccEntryExCondata.length > 0) {
                this.containerArray = data.ccEntryExCondata;
              } else {
                this.containerArray = [];
              }

              this.EdiExecutionModel.allModuleId =
                data.ccImportDetails[0].allModuleId;
            }

            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },

    editable(item, index) {
      this.uploadIndex = index;
      Object.keys(this.UploadChecklist).map((x) => {
        this.UploadChecklist[x] = item[x] || "";
      });
    },
    viewdoc(val) {
      // window.open("http://13.229.240.246/CCEDiExecution/" + val);
      window.open(`${this.docURL}/CCEDiExecution/` + val);
    },
    approvedRejected() {},

    addNew() {
      this.$router.push({
        path: "/client/addClient",
      });
    },
    onFileChange(index, ID) {
      let files = event.target.files || event.dataTransfer.files;

      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        formData.append(
          "moduleId",
          this.$sessionsStorage.get("editCcImportId")
        );
        if (ID == "VGM") {
          if (this.EdiExecutionModel.ccType == "Export") {
            formData.append("staticFileName", "CC_Export_ShipperVGM");
          } else {
            formData.append("staticFileName", "CC_Import_ShipperVGM");
          }
        } else if (ID == "Approve_CheckList") {
          if (this.EdiExecutionModel.ccType == "Export") {
            formData.append("staticFileName", "CC_Export_ApprovedChecklist");
          } else {
            formData.append("staticFileName", "CC_Import_ApprovedChecklist");
          }
        } else if (ID == "SHIPINV") {
          if (this.EdiExecutionModel.ccType == "Export") {
            formData.append("staticFileName", "CC_Export_ShipperInv");
          } else {
            formData.append("staticFileName", "CC_Import_ShipperInv");
          }
        } else {
          if (this.EdiExecutionModel.ccType == "Export") {
            formData.append("staticFileName", "CC_Export_ShippingBill" + index);
          } else {
            formData.append("staticFileName", "CC_Import_ShippingBill" + index);
          }
        }
        if (this.EdiExecutionModel.ccType == "Export") {
          formData.append("upload_dir_folderName", "CC_Export_Uploads");
        } else {
          formData.append("upload_dir_folderName", "CC_Import_Uploads");
        }
      }

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAll.php`, formData, config)
        .then((result) => {
          if (ID == "VGM") {
            this.EdiExecutionModel.vgmUpload = result.data;
          } else if (ID == "Approve_CheckList") {
            this.EdiExecutionModel.checklistUpload = result.data;
          } else if (ID == "SHIPINV") {
            this.multiShippingBill[index].shipperInvUpload = result.data;
          } else {
            this.multiShippingBill[index].sbUpload = result.data;
          }
        })
        .catch((err) => {
          throw err;
        });
    },

    validateCheckList(id) {
      let validate_new = true;

      Object.keys(this.errorArrayEdiExecution).map((x) => {
        if (
          this.EdiExecutionModel[x] == "" &&
          (x == "DIN" || x == "IRN") &&
          id == ""
        ) {
          validate_new = false;
          this.errorArrayEdiExecution[x] = this.arrayErrorEdit[x];
        } else if (this.EdiExecutionModel[x] == "" && id != "") {
          validate_new = false;
          this.errorArrayEdiExecution[x] = this.arrayErrorEdit[x];
        } else {
          this.errorArrayEdiExecution[x] = "";
        }
      });

      if (id == "") {
        Object.keys(this.errorChecklist).map((x) => {
          if (this.UploadChecklist[x] == "") {
            validate_new = false;
            this.errorChecklist[x] = this.arrayErrorCheckList[x];
          } else {
            this.errorChecklist[x] = "";
          }
        });
      }

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    checkSlinePayment() 
    {
      return new Promise((resolve)=>{

        let payLoad = {
          "module_type":"CC Export",
          "allModuleId":this.ALLMODULE,
          "assignment_no":this.JOBSERIES,
          "type":this.TYPE,
        };
        // console.log("MypayLoad=>",payLoad.length);return false;
        if(payLoad !="")
        {
          let options = 
          {
            method: "POST",
            url: `${URL_BASE}/Api_SlineBillingCCExport/checkSlinePaymentcreated.php`,
            data: JSON.stringify(payLoad),
            crossDomain: true,
            headers: 
            {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
          .then((result) => 
          {
            const { statusText, status, data } = result;
            if ( status == 200 && data) 
            {
              console.log(data);
              console.log(data.find);
              if(data.find == 1)
              {
                this.invnoErrFlag = true;
                this.syncType= data.moduleType;
                this.syncSeries=data.mainSalesSeries;
              }else if(data.find == 0){
                  this.invnoErrFlag = false;
              }
              this.syncFlag = true;
              return resolve(!this.invnoErrFlag)
            }
          })
          .catch((error) => {});
        }
      })
    },
    async emailChecklist(id) {
      if(id == "PAYTEST") 
      {
        let checkValueExit=await this.checkSlinePayment();
        console.log("checkValueExit",checkValueExit);

        if(!checkValueExit)
        {
          if(this.syncType!="CC Export")
          {
            this.alert.content = "The Payment Request has Already been Raised in '"+this.syncType+"' Assignment No. '"+this.syncSeries+"'";
            this.$refs["message"].open();
            return false;
          }
        }
      }
      // if (this.EdiExecutionModel.vgmBy == "") {
      //   this.alert.content = "Select VGM By";

      //   this.$refs["message"].open();
      //   return false;
      // }
      this.EdiExecutionModel["multiShippingBill"] = this.multiShippingBill;
      
      // Added By Priyanshu Singh Start
      this.$sessionsStorage.set("allModuleId",this.ALLMODULE);
      this.$sessionsStorage.set("TYPE",this.TYPE);
      this.$sessionsStorage.set("JOBSERIES",this.JOBSERIES);
      this.$sessionsStorage.set("EXPORTER",this.EXPORTER);
      // Added By Priyanshu Singh End

      this.pageRoute = id;
      this.validateCheckList(id);

      this.EdiExecutionModel["ccImportId"] =
        this.$sessionsStorage.get("editCcImportId");
        

      if (this.ccExecDetail.length > 0) {
        this.EdiExecutionModel.ediExecutionId =
          this.ccExecDetail[0].ediExecutionId;
      }

      // Added By Priyanshu Singh Start
      this.EdiExecutionModel["ccImportId"] =this.$sessionsStorage.get("editCcImportId");
      this.EdiExecutionModel["allModuleId"] =this.$sessionsStorage.get("allModuleId");
      this.EdiExecutionModel["TYPE"] =this.$sessionsStorage.get("TYPE");
      this.EdiExecutionModel["JOBSERIES"] =this.$sessionsStorage.get("JOBSERIES");
      this.EdiExecutionModel["EXPORTER"] =this.$sessionsStorage.get("EXPORTER");
      // Added By Priyanshu Singh End

      let Obj = {
        EdiExecutionModel: this.EdiExecutionModel,
        //   UploadChecklist: this.UploadChecklist,
        onlyExecMain: id == "" ? "" : "fsdf",
      };

      if (this.validate == true) {
        this.isLoading = true;
        if (id == "vgm") {
          $("#addButtonLoaderVgm").css("display", "none");
          $("#loaderVgm").css("display", "block");
        } else if (id == "handover") {
          $("#addButtonLoaderHand").css("display", "none");
          $("#loaderHand").css("display", "block");
        } else if (id == "BL") {
          $("#addButtonLoaderBL").css("display", "none");
          $("#loaderBL").css("display", "block");
        } else {
          $("#addButtonLoaderPay").css("display", "none");
          $("#loaderPay").css("display", "block");
        }
        
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Custom/addEdiExecution.php`,
          data: JSON.stringify(Obj),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              // alert("hellow");
              // console.log("My Data=>",data);
              // return false;
              // // if (this.mainEntryData[0].newContainerFlow == "1") {
                // Added By Priyanshu Singh Start 
                this.$sessionsStorage.set("editCCExecutionId",data.ediExecutionId);
                  // Added By Priyanshu Singh End
              //   this.factoryStuffing.editCCExecutionId = data.ediExecutionId;
              // }
              // Object.keys(this.UploadChecklist).map(x => {
              //   this.UploadChecklist[x] = "";ediExecutionId
              // });

              //  this.uploadIndex = 0;
              //   this.getData();
              if (id != "") {
                this.alert.content = "Data Updated Succesfully";
                if (id == "0") {
                  this.$refs["message"].open();
                } else {
                  this.$refs["alertAddSeaImp"].open();
                }
              }

              if (id == "vgm") {
                $("#addButtonLoaderVgm").css("display", "block");
                $("#loaderVgm").css("display", "none");
              } else if (id == "BL") {
                $("#addButtonLoaderBL").css("display", "block");
                $("#loaderBL").css("display", "none");
              } else if (id == "handover") {
                $("#addButtonLoaderHand").css("display", "block");
                $("#loaderHand").css("display", "none");
              } else {
                $("#addButtonLoaderPay").css("display", "block");
                $("#loaderPay").css("display", "none");
              }
              this.isLoading = false;
              if (id == "0") {
                this.getData();
              }
              // this.isLoading = false;
            }
          })
          .catch((error) => {});
      }
    },

    previousFFView() {
      window.history.go(-1);
      // if (this.EdiExecutionModel.ccType == "Import") {
      //   this.$router.push({
      //     path: "/CCImport/CCImportEntry"
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/CCImport/CCExportEntry"
      //   });
      // }
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// newEdiExecution.vue?1b0c64e8